import React from 'react'

export default function EditOutcome() {
  return (
    <div>EditOutcome</div>
  )
}
